// Load userData from localStorage on initialization
const loadUserDataFromStorage = () => {
  try {
    const storedUserData = localStorage.getItem('userData');
    if (storedUserData) {
      return JSON.parse(storedUserData);
    }
  } catch (error) {
    console.error('Error loading userData from localStorage:', error);
  }
  return null;
};

// Load currentUser from localStorage on initialization
const loadCurrentUserFromStorage = () => {
  try {
    const storedUser = localStorage.getItem('currentUser');
    if (storedUser) {
      return JSON.parse(storedUser);
    }
  } catch (error) {
    console.error('Error loading currentUser from localStorage:', error);
  }
  return null;
};

// Load resetEmail from localStorage on initialization
const loadResetEmailFromStorage = () => {
  try {
    const storedEmail = localStorage.getItem('resetEmail');
    return storedEmail || null;
  } catch (error) {
    console.error('Error loading resetEmail from localStorage:', error);
  }
  return null;
};

export const state = {
  currentUser: loadCurrentUserFromStorage(),
  userData: loadUserDataFromStorage(),
  resetEmail: loadResetEmailFromStorage(),
};

export const getters = {
  loggedIn: (state) => !!state.currentUser,
  currentUser: (state) => state.currentUser,
  userData: (state) => state.userData,
  resetEmail: (state) => state.resetEmail,
};

export const mutations = {
  SET_USER(state, user) {
    state.currentUser = user;
    if (user && (user.id || user._id || user.email || user.name)) {
      localStorage.setItem('currentUser', JSON.stringify(user));
    }
  },
  SET_USER_DATA(state, userData) {
    state.userData = userData;
    if (userData && (userData.id || userData._id || userData.email || userData.name)) {
      localStorage.setItem('userData', JSON.stringify(userData));
    }
  },
  SET_RESET_EMAIL(state, email) {
    state.resetEmail = email;
    if (email) {
      localStorage.setItem('resetEmail', email);
    } else {
      localStorage.removeItem('resetEmail');
    }
  },
  CLEAR_USER(state) {
    state.currentUser = null;
    state.userData = null;
    state.resetEmail = null;
    localStorage.removeItem('currentUser');
    localStorage.removeItem('userData');
    localStorage.removeItem('resetEmail');
  },
};

export const actions = {
  setUser({ commit }, user) {
    commit('SET_USER', user);
  },
  setUserData({ commit }, userData) {
    commit('SET_USER_DATA', userData);
  },
  setResetEmail({ commit }, email) {
    commit('SET_RESET_EMAIL', email);
  },
  clearUser({ commit }) {
    commit('CLEAR_USER');
  },
};